import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'user_right': 'String!',
	'user_guid': 'String!',
	'active': 'String!',
};

export default gql(`
	mutation user_right( ${ HelperGraphql.createFields( fields ) } ) {
	    user_right( ${ HelperGraphql.createVariables( fields ) } ) {
	       	user_right
			active
	    }
	}
`);

